import { takeLatest, call, put } from 'redux-saga/effects';
import { postPatientAcknowledgementSuccess, postPatientAcknowledgementFailure, putPatientAcknowledgementSuccess, putPatientAcknowledgementFailure } from './slice';
import { apiGet, apiPost, apiPut, apiDelete, apiUpload } from '../../../../api/client';
function* postPatientAcknowledgementRequest(action) {
    try {
const response = yield call(apiPost, 'api/post-patient-acknowledgement', action.payload);
        yield put(postPatientAcknowledgementSuccess(response));
    } catch (error) {
        yield put(postPatientAcknowledgementFailure(error?.response?.message || error));
    }
}


function* putPatientAcknowledgementRequest(action) {
    try {
const response = yield call(apiPut, `api/edit-patient-acknowledgement/${action.payload._id}`, action.payload);
        yield put(putPatientAcknowledgementSuccess(response));
    } catch (error) {
        yield put(putPatientAcknowledgementFailure(error?.response?.message || error));
    }
}

function* saga() {
    yield takeLatest('patientAcknowledgement/postPatientAcknowledgementRequest', postPatientAcknowledgementRequest);
    yield takeLatest('patientAcknowledgement/putPatientAcknowledgementRequest', putPatientAcknowledgementRequest);
}

export default saga;